import React, { useState, useEffect, useMemo } from 'react';
import { Tooltip, Box, Typography, List, ListItem, ListItemIcon } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import i18n from '../../utilities/i18n';

const TableWarningPopUp = ({ formWarningData, formWarningStatus }) => {
    const [missingFields, setMissingFields] = useState([]);

    useEffect(() => {
        let fields = [];
        formWarningData?.forEach((item, index) => {
            Object.keys(item).forEach((key) => {
                // Ignore tabName key and check for empty/null values
                if (key !== 'tabName' && (item[key] === '' || item[key] === null || item[key] === 'none')) {
                    fields.push({
                        id: `${index}-${key}`,
                        label: item.tabName ? `${item.tabName} - ${key}` : key
                    });
                }
            });
        });
        setMissingFields(fields);
    }, [formWarningStatus, formWarningData]);

    // Constructing the tooltip content
    const tooltipContent = useMemo(() => (
        <Box sx={{ p: 1, color: '#606162' }}>
            {missingFields.length > 0 && (
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {i18n.t("warning.followingMandatoryFields")} :
                </Typography>
            )}
            <List dense sx={{ p: 0 }}>
                {missingFields.map((field) => (
                    <ListItem key={field.id} disableGutters sx={{ py: 0, alignItems: 'center' }}>
                        <ListItemIcon sx={{ minWidth: '20px' }}>
                            <FiberManualRecordIcon sx={{ fontSize: '8px', color: '#606162' }} />
                        </ListItemIcon>
                        <Typography variant="caption">{field.label}</Typography>
                    </ListItem>
                ))}
            </List>
        </Box>
    ), [missingFields]);

    return (
        <Tooltip
            title={tooltipContent}
            placement="bottom-start"
            enterDelay={100}
            leaveDelay={250}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: '#ffbaba',
                        border: '1px solid #ff6347',
                        borderRadius: '4px',
                        maxWidth: 'none',
                        boxShadow: 2
                    },
                },
            }}
        >
            <Box component="span" sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                <PriorityHighIcon 
                    sx={{ 
                        color: '#d32f2f', // Standard MUI error color
                        fontSize: '1.2rem' 
                    }} 
                />
            </Box>
        </Tooltip>
    );
};

export default TableWarningPopUp;